<template>
  <div class="Home">
    <!-- 黑头 -->
    <home-header></home-header>
    <div class="main">
      <div class="maincontent">
        <!-- 我们的使命和目标 -->
        <p class="maintitie">{{ $t("home.title") }}</p>
        <div class="section1">
          <div class="section1-text">

            <p class="textcontent-cn">{{ $t("home.text1") }}</p>

            <router-link to="/About" class="textcontent-en" v-if="isEn" >
              <button class="section1-button">
                {{ $t("home.readMore")}}
                <img class="section1-buttonimg" src="../../assets/images/more_icon.png"/>
              </button>
            </router-link>

            <router-link to="/About" class="textcontent-cn"  v-else>
              <button class="section1-button">
                {{ $t("home.readMore")}}
                <img class="section1-buttonimg" src="../../assets/images/more_icon.png"/>
              </button>
            </router-link>

          </div>

          <div class="section1-text2">
            <p class="section1-text2-1 flex-all-center">
              {{ $t("home.number1") }}
            </p>
            <p class="section1-text2-2 flex-all-center">
              {{ $t("home.text2") }}
            </p>
            <p class="section1-text2-3 flex-all-center">
              {{ $t("home.date1") }}
            </p>
          </div>  

        </div>

        <!-- 我们的主要服务 -->
        <p class="maintitie">{{ $t("home.text3") }}</p>

        <div class="section2">
          <div class="service-item slideInLeft">
            <div class="service-overlay">
              <div class="service-text">{{ $t("home.text4") }}</div>
              <router-link to="/ourServiceBank">

                <el-button class="btn "> {{ $t("home.learnMore") }}</el-button>

              </router-link>
            </div>
          </div>

          <div class="service-item slideInUp">
            <div class="service-overlay">
              <div class="service-text">{{ $t("home.text5") }}</div>
              <router-link to="/ourServiceFixed">
                <el-button class="btn " >{{ $t("home.learnMore") }}</el-button>
              </router-link>
            </div>
          </div>

          <div class="service-item slideInUp">
            <div class="service-overlay">
              <div class="service-text">{{ $t("home.text6") }}</div>
              <router-link to="/ourServiceDigital">
                <el-button class="btn " >{{ $t("home.learnMore") }}</el-button>
              </router-link>
            </div>
          </div>

          <div class="service-item slideInRight">
            <div class="service-overlay">
              <div class="service-text">{{ $t("home.text7") }}</div>
              <router-link to="/ourServiceAI">
                <el-button class="btn " >{{ $t("home.learnMore") }}</el-button>
                </router-link>
            </div>
          </div>
        </div>

        <!-- 专业知识 , 互相信赖 , 量身定制 , 不懈努力 -->
        <div class="section3">

          <div class="section3-1">
            <div class="info-item slideInUp">
              <img  class="info-icon" src="../../assets/images/home_pic1.png" :alt="$t('home.text8')"/>
              <p class="info-title">{{ $t("home.text8") }}</p>

              <p class="info-description textcontent-en"  v-if="isEn">{{ $t("home.text9") }}</p>
              <p class="info-description textcontent-cn" v-else>{{ $t("home.text9") }}</p>

            </div>

             <div class="info-item slideInUp">
              <img class="info-icon" src="../../assets/images/home_pic2.png" :alt="$t('home.text10')"/>
              <p class="info-title">{{ $t("home.text10") }}</p>

              <p class="info-description textcontent-en"  v-if="isEn">{{ $t("home.text11") }}</p>
              <p class="info-description textcontent-cn" v-else>{{ $t("home.text11") }}</p>

            </div>
          </div>

          <div class="section3-2">
            <div class="info-item slideInUp">
              <img class="info-icon" src="../../assets/images/home_pic3.png" :alt="$t('home.text12')"/>
              <p class="info-title">{{ $t("home.text12") }}</p>

              <p class="info-description textcontent-en"  v-if="isEn">{{ $t("home.text13") }}</p>
              <p class="info-description textcontent-cn" v-else>{{ $t("home.text13") }}</p>

             </div>

            <div class="info-item slideInUp">
              <img class="info-icon" src="../../assets/images/home_pic4.png" :alt="$t('home.text14')"/>
              <p class="info-title">{{ $t("home.text14") }}</p>
              <p class="info-title">{{ $t("home.text14_1") }}</p>

              <p class="info-description textcontent-en"  v-if="isEn">{{ $t("home.text15") }}</p>
              <p class="info-description textcontent-cn" v-else>{{ $t("home.text15") }}</p>

            </div>
          </div>

        </div>
        <!-- 客户需提供 -->

        <div class="section4">
          <div class="section4text banner-item slideInLeft">
            <p class="section4title">{{ $t("home.text16") }}</p>

            <!-- <p class="textcontent-en" v-if="isEn">{{ $t("home.text17") }}</p>
            <p class="textcontent-cn" v-else>{{ $t("home.text17") }}</p> -->
            <p class="textcontent-cn">{{ $t("home.text17") }}</p>

            <router-link to="/homeUserNotice">
              <button class="section4_button">{{ $t("home.text18") }}</button>
            </router-link>
          </div>
          <img class="section4img banner-item slideInRight" src="../../assets/images/home_banner1.png" />
        </div>
      </div>
    </div>

    <!-- 底部留白 -->
    <div class="footer"></div>
  </div>
</template>

<script>
import HomeHeader from './homecomponents/HomeHeader.vue';
import { mapState } from "vuex";

export default {
  name: "Home",
  components:{
    HomeHeader
  },
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {

    };
  },
  mounted() {
    // 确保元素在组件加载后存在，绑定事件
    this.initAnimations();
  },
  created(){

  },
  methods: {
    initAnimations() {
      const homeSection2 = document.querySelector(".section2");
      const homeSection3 = document.querySelector(".section3");
      const homeSection4 = document.querySelector(".section4");

      const isElementInViewport = (el, offset = 0) => {
        if (!el) return false; // 检查元素是否存在
        const rect = el.getBoundingClientRect();
        return (
          rect.top <
          (window.innerHeight || document.documentElement.clientHeight) - offset
        );
      };

      const playSlideInAnimation = (section, className, offset) => {
        const items = section ? section.querySelectorAll(className) : [];
        if (isElementInViewport(section, offset)) {
          items.forEach((item) => item.classList.add("visible"));
          window.removeEventListener("scroll", playSlideInAnimation);
        }
      };

      window.addEventListener("scroll", function () {
        playSlideInAnimation(homeSection2, ".service-item", 50);
        playSlideInAnimation(homeSection3, ".info-item", 50);
        playSlideInAnimation(homeSection4, ".banner-item", 50);
      });
    },
  },
  beforeUnmount() {
    // 组件销毁前移除监听，防止内存泄漏
    window.removeEventListener("scroll", this.initAnimations);
  },

};
</script>

<style lang="scss" scoped>
.Home{
    color: #000;
    width: 100%;
}

.main{
  display: flex;
  justify-content: center;

  .maincontent{
   max-width: 1200px;
   text-align:justify;
   width: 100%;
   line-height: 32px;
   font-size: 17px;

    p{
      font-family:"OPPO-R";
    }

    .textcontent-cn{
      text-indent: 34px;
      text-align:justify;
    }

    .textcontent-en{
      text-indent: 0px;
      text-align: justify;

    }

    .maintitie {
      font-family: "OPPO-B";
      color: #000;
      font-size: 40px;
      text-align: center;
      margin-top: 80px;
    }

    .section1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
        
        .section1-text{
        width: 672px;
        }

        .section1-button {
        font-size: 15px;
        background-color: #fff;
        color: #570a0b;
        border: none;
        transition: filter 0.3s ease;
        }

        .section1-buttonimg {
        width: 14px;
        transition: filter 0.3s ease;
        }

        .section1-button:hover {
        color: #000;
        }

        .section1_button:hover .section1-buttonimg {
        color: #000;
        filter: brightness(0);
        }

        .section1-text2{
          .section1-text2-1{
            font-size: 47px;
            font-family: "OPPO-B";
          }
          .section1-text2-2{
            font-size: 15px;
            margin-top: 16px;
          }
          .section1-text2-3{
            font-family: "OPPO-L";
            margin-top: 4px;
            font-weight: bold;
          }
        }
    }

    .section2 {
      margin-top: 80px;
      display: flex;
      justify-content: space-between;

        .service-item {
          position: relative;
          width: 290px;
          height: 400px;
          background-image: url("../../assets/images/home_overlap.jpg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-attachment: fixed;

          .service-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin-top: 120px;            
            background-color: rgba(0, 0, 0, 0);
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: center;
            color: white;

              el-button {
                background-color: white;
                color: black;
                border-radius: 4px;
                font-family: "OPPO-M";
              }

              .btn {
                width: auto;
                
              }

              .service-text {
              height: 100px;
              font-size: 20px;
              margin-bottom: 80px;
              text-align: center;
              font-family: "OPPO-R";
              //word-break: break-all;
              //word-wrap: break-word;
              }
          }
        }
    }

    .section3{
      margin-top: 120px;
      font-family: "OPPO-R";


        .section3-1
        {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        .section3-2
        {
          margin-top: 80px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }

        .info-item {
          width: 391px;
          text-align: center;
          justify-content: flex-start;

          .info-icon {
            width: 130px;
            height: 130px;
            object-fit: contain;
          }

          .info-title {
            font-size: 18px;
            font-family: "OPPO-B";
          }

          .info-description {
            margin-top: 15px;
            line-height: 26px;
            
          }
        }
    }

     .section4{
      width: 100%;
      margin-top: 120px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .section4title
      {
        text-align: center;
        font-size: 18px;
        font-family: "OPPO-B";
      }
      .section4text{
        font-family: "OPPO-R";
        margin-top: 14px;
        width: 347px;
      }

      .section4_button {
        font-family: "OPPO-M";
        margin-top: 13px;
        font-size: 15px;
        background-color: #570a0b;
        color: #ffffff;
        padding: 10px 20px;
        border: none;
        border-radius: 8px;
        transition: background-color 0.3s ease;
      }

      .section4_button:hover {
        background-color: #fff;
        color: #570a0b;
      }
      .section4img
      {
        width: 562px;
      }
     }
  }
}

.footer{
  margin-top: 120px;
}

// 这里开始是写动画效果
.slideInLeft.visible {
  animation: slideInFromLeft 1.5s ease;
}
.slideInUp.visible {
  animation: slideInFromUp 1.5s ease;
}
.slideInRight.visible {
  animation: slideInFromRight 1.5s ease;
}

@keyframes slideInFromLeft {
  0% {
    transform: translate3d(-120%, 0, 0);
    visibility: visible;
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slideInFromUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes slideInFromRight {
  0% {
    transform: translate3d(120%, 0, 0);
    visibility: visible;
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
// 移动端
@media (max-width: 768px) {

.main{
  display: flex;
  justify-content: center;

  .maincontent{
    text-align: center;
    align-items: center;
    line-height: 32px;
    font-size: 17px;
    width: 90%;

    p{
      font-family:"OPPO-R";
    }

    .textcontent-cn{
      width: 100%;
      text-indent: 34px;
      text-align:justify;
    }

    .textcontent-en{
      width: 100%;
      text-indent: 0px;
      text-align:center;
    }

    .maintitie {
      font-family: "OPPO-B";
      color: #000;
      font-size: 40px;
      text-align: center;
      margin-top: 40px;
      line-height: 40px;
    }

    .section1 {
      flex-direction: column;
      margin-top: 40px;
      width: 100%;
        
        .section1-text{
        width: 90%;
        }

        .section1-button {
        font-size: 15px;
        background-color: #fff;
        color: #570a0b;
        border: none;
        transition: filter 0.3s ease;
        }

        .section1-buttonimg {

        width: 14px;
        transition: filter 0.3s ease;
        }

        .section1-button:hover {
        color: #000;
        }

        .section1_button:hover .section1-buttonimg {
        color: #000;
        filter: brightness(0);
        }

        .section1-text2{
          margin-top: 40px;
          .section1-text2-1{
            font-size: 47px;
            font-family: "OPPO-B";
          }
          .section1-text2-2{
            font-size: 15px;
            margin-top: 16px;
          }
          .section1-text2-3{
            font-family: "OPPO-L";
            margin-top: 4px;
            font-weight: bold;
          }
        }
    }

    .section2 {
      margin-top: 80px;
      display: flex;
      justify-content: space-between;

        .service-item {
          position: relative;
          width: 22%;
          height: 300px;
          background-image: url("../../assets/images/home_overlap.jpg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-attachment: fixed;

            .service-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin-top: 0px;
            background-color: rgba(0, 0, 0, 0);
            display: flex;
            flex-direction: column;
            justify-content: end;
            align-items: center;
            overflow: hidden;  
            color: white;

              el-button {
                background-color: white;
                color: black;
                border-radius: 4px;
                font-family: "OPPO-M";
              }

              .btn {
                width: 80px;
                font-size: 10px;
                display: flex;             
                align-items: center;        
                justify-content: center;  
              }

              .service-text {
                height: 100px;
                font-size: 12px;
                //margin-bottom: 40px;
                text-align: center;              
                align-items: flex-start;
                font-family: "OPPO-R";
              }
          }
        }
    }

    .section3{
      margin-top: 40px;
      font-family: "OPPO-R";

        .section3-1
        {
          display: flex;
          align-items: flex-start; 
          justify-content: space-between;
          flex-direction: row;
          
        }

        .section3-2
        {
          margin-top: 40px;
          display: flex;
          align-items: flex-start; 
          justify-content: space-between;
          flex-direction: row;
        }

        .info-item {
          width: 40%;
          text-align: center;


          .info-icon {
            width: 30%;
            height: 30%;
            object-fit: contain;

          }

          .info-title {
            font-size: 18px;
            font-family: "OPPO-B";

          }

          .info-description {
            margin-top: 15px;
            line-height: 26px;
          }
        }
    }

     .section4{
      width: 100%;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .section4title{
        text-align: center;
        font-size: 18px;
        font-family: "OPPO-B";
      }
      .section4text{
        font-family: "OPPO-R";
        margin-top: 14px;
        width: 100%;
      }

      .section4_button {
        font-family: "OPPO-M";
        margin-top: 13px;
        font-size: 15px;
        background-color: #570a0b;
        color: #ffffff;
        padding: 10px 20px;
        border: none;
        border-radius: 8px;
        transition: background-color 0.3s ease;
      }

      .section4_button:hover {
        background-color: #fff;
        color: #570a0b;
      }
      
      .section4img
      {
        margin-top: 40px;
        width: 90%;
      }
     }
  }
}
.footer
{
  margin-top: 40px;
}

  /* 调整动画样式，确保在移动端也能正常显示 */
  @keyframes slideInFromLeft {
    0% {
      transform: translate3d(-100%, 0, 0);
      visibility: visible;
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
  
  @keyframes slideInFromRight {
    0% {
      transform: translate3d(100%, 0, 0);
      visibility: visible;
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
  
  @keyframes slideInFromUp {
    0% {
      transform: translate3d(0, 50%, 0);
      visibility: visible;
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
  
  /* 确保动画容器可见 */
  .slideInLeft, .slideInRight, .slideInUp {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .slideInLeft.visible, .slideInRight.visible, .slideInUp.visible {
    opacity: 1;
  }
}
</style>
